const routes = [
	{
		path: '/teachingMaterial/teaching-center-list',
		name: 'teachingMaterial/teaching-center',
		component: () =>
			import('../views/TeachingMaterial/teaching-center-list.vue')
	}
];

export default {
	routes
};
